import { render } from "./SellTransSell.vue?vue&type=template&id=2b0d1e6d&scoped=true"
import script from "./SellTransSell.vue?vue&type=script&lang=js"
export * from "./SellTransSell.vue?vue&type=script&lang=js"

import "./SellTransSell.vue?vue&type=style&index=0&id=2b0d1e6d&lang=scss&scoped=true"

import exportComponent from "D:\\svn_gongzuo\\_____base\\GoPay\\v3_gopay\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b0d1e6d"]])

export default __exports__